export default __webpack_public_path__ + "static/media/wolfComplete.b1e93f99.jpg";